import * as React from "react";
interface Props {
    text: string;
    disabled?: boolean;
}

const BorderName = ({ text, disabled }: Props) =>
    <span dangerouslySetInnerHTML={{ __html: text.replace(/(\►)/g, `<span class="triangle ${disabled ? "text-disabled" : ""}">$1</span>`) }} />;

export default BorderName;